import React from 'react';
import { useSelector } from 'react-redux';
import List from '@mui/material/List';
import PlanItem from './PlanItem';
import { getMapLayers } from '../reducers/mapLayers';

const Plan = () => {
  const layers = useSelector(getMapLayers);
  const planItems = layers.filter((layer) => layer.group === 'bg').map((layer) => <PlanItem key={layer.id} id={layer.id} />);

  return (
    <List>
      {planItems}
    </List>
  );
};

export default Plan;
